"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const types_1 = require("../types");
class LoginProvider extends DataProvider_1.default {
    constructor(api, eventEmitter) {
        super(api, eventEmitter);
        api.setupTokenRefresher({
            refreshToken: (token) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                try {
                    yield this.refreshTokenV2({ token });
                }
                catch (e) {
                    yield this.logout();
                    this.eventEmitter && this.eventEmitter(types_1.EVENT_NAMES.SET_USER, { user: null, authorities: null });
                    throw e;
                }
            }),
            logout: (client) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                yield this._logout(false, client);
                this.eventEmitter && this.eventEmitter(types_1.EVENT_NAMES.SET_USER, { user: null, authorities: null });
            }),
            listenForTokensUpdated: () => tslib_1.__awaiter(this, void 0, void 0, function* () {
                return this.api.subscribe({
                    query: graphql_tag_1.default `
              subscription TokensUpdated {
                tokensUpdated {
                  ${this.getFragment("LoginData")}
                }
              }
            `,
                }, data => this.setLoginData(data.tokensUpdated));
            }),
        });
    }
    get fragments() {
        return {
            LoginData: () => `
        ... on LoginData {
          longLiveToken {
            token
          }
          shortLiveToken {
            token
          }
          user {
            ${this.getFragment("User")}
            emailVerified
          }
          authorities
        }
      `,
        };
    }
    setLoginData(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.api.updateTokens(data.shortLiveToken.token, data.longLiveToken.token);
            this.eventEmitter && this.eventEmitter(types_1.EVENT_NAMES.SET_USER, { user: data.user, authorities: data.authorities });
        });
    }
    login({ password, email }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query Login($password: String!, $email: String!) {
          login(password: $password, email: $email) {
            ${this.getFragment("LoginData")}
          }
        }
      `,
                variables: {
                    email,
                    password,
                },
                skipRefresh: true,
            });
            yield this.setLoginData(resp.data.login);
            return resp.data.login;
        });
    }
    facebookLogin({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query FacebookLogin($data: InputFacebookLoginData!) {
          facebookLogin(data: $data) {
            ${this.getFragment("LoginData")}
          }
        }
      `,
                variables: { data },
                skipRefresh: true,
            });
            yield this.setLoginData(resp.data.facebookLogin);
            return resp.data.facebookLogin;
        });
    }
    twitterLogin({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query TwitterLogin($data: InputTwitterLoginData!) {
          twitterLogin(data: $data) {
            ${this.getFragment("LoginData")}
          }
        }
      `,
                variables: { data },
                skipRefresh: true,
            });
            yield this.setLoginData(resp.data.twitterLogin);
            return resp.data.twitterLogin;
        });
    }
    twitterLoginGetAuthUrl(data) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query(Object.assign(Object.assign({ query: graphql_tag_1.default `
        query TwitterLoginGetAuthUrl($callbackUrl: String) {
          twitterLoginGetAuthUrl(callbackUrl: $callbackUrl)
        }
      ` }, (data && data.callbackUrl ? { variables: { callbackUrl: data.callbackUrl } } : {})), { skipRefresh: true }));
            return resp.data.twitterLoginGetAuthUrl;
        });
    }
    phoneLoginStart({ phone }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        mutation($phone: String!) {
          phoneLoginStart(phone: $phone)
        }
      `,
                variables: { phone },
                skipRefresh: true,
            });
            return resp.data.phoneLoginStart;
        });
    }
    phoneLogin({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        mutation($data: InputPhoneLoginData!) {
          phoneLogin(data: $data) {
            ${this.getFragment("LoginData")}
          }
        }
      `,
                variables: { data },
                skipRefresh: true,
            });
            yield this.setLoginData(resp.data.phoneLogin);
            return resp.data.phoneLogin;
        });
    }
    refreshTokenV2({ token, createNewLongLiveToken = false, }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query refreshTokenV2($token: String!, $createNewLongLiveToken: Boolean) {
          refreshTokenV2(token: $token, createNewLongLiveToken: $createNewLongLiveToken) {
            ${this.getFragment("LoginData")}
          }
        }
      `,
                variables: { token, createNewLongLiveToken },
                skipRefresh: true,
            });
            yield this.setLoginData(resp.data.refreshTokenV2);
            return resp.data.refreshTokenV2;
        });
    }
    join({ data }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const resp = yield this.api.query({
                query: graphql_tag_1.default `
        query joint($data: InputJoinData!) {
          join(data: $data) {
            ${this.getFragment("LoginData")}
          }
        }
      `,
                variables: { data },
                skipRefresh: true,
            });
            yield this.setLoginData(resp.data.join);
            return resp.data.join;
        });
    }
    logout() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this._logout(true, undefined);
        });
    }
    _logout(revokeToken, client) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.logoutPromise) {
                this.logoutPromise = new Promise((resolve) => tslib_1.__awaiter(this, void 0, void 0, function* () {
                    if (revokeToken) {
                        try {
                            this.api.setCallErrorHandler(false);
                            yield this.api.query({
                                query: graphql_tag_1.default `
                query {
                  revokeToken
                }
              `,
                                variables: {},
                                skipRefresh: true,
                                ignoreUnauthenticatedErrors: true,
                            });
                            // eslint-disable-next-line no-empty
                        }
                        catch (ignored) { }
                    }
                    yield this.api.updateTokens("", "");
                    this.api.close(client);
                    this.logoutPromise = undefined;
                    resolve();
                }));
            }
            return this.logoutPromise;
        });
    }
    getLongLiveToken() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.api.getLongLiveToken();
        });
    }
    setLongLiveToken(token) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.api.updateTokens("", token);
        });
    }
    longLiveTokenByUser(userId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            return this.query("longLiveTokenByUser", { userId });
        });
    }
}
exports.LoginProvider = LoginProvider;
//# sourceMappingURL=LoginProvider.js.map